export const getFlowExecutionUrl = (flowSid: string | undefined, executionSid: string | undefined) => {
	return `https://www.twilio.com/console/studio/flows/${flowSid}/executions/${executionSid}`;
};

export const getServiceChannelDetailsUrl = (sid: string | undefined, serviceSid: string | undefined) => {
	return `https://www.twilio.com/console/chat/services/${serviceSid}/channels/${sid}`;
};

export const getCallDetailsUrl = (sid: string | undefined) => {
	return `https://www.twilio.com/console/voice/calls/logs/${sid}`;
};

export const getVoiceInsightsUrl = (sid: string | undefined) => {
	return `https://www.twilio.com/console/voice/calls/logs/pstn/${sid}/metrics`;
};
